import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faServer,
  faMicrochip,
  faNetworkWired,
  faThermometerHalf,
  faWater,
  faBatteryThreeQuarters,
  faSun,
  faWind,
  faCloud,
  faLeaf,
  faSignal,
  faSatelliteDish,
  faBolt,
  faTachometerAlt,
  faCube,
  faBox,
  faIndustry,
  faWarehouse,
  faMapMarkerAlt,
  faMap,
  faGlobe,
  faBroadcastTower
} from '@fortawesome/free-solid-svg-icons';

// Icon map for device profiles
export const iconMap = {
  server: faServer,
  microchip: faMicrochip,
  network: faNetworkWired,
  thermometer: faThermometerHalf,
  water: faWater,
  battery: faBatteryThreeQuarters,
  sun: faSun,
  wind: faWind,
  cloud: faCloud,
  leaf: faLeaf,
  signal: faSignal,
  satellite: faSatelliteDish,
  bolt: faBolt,
  gauge: faTachometerAlt,
  cube: faCube,
  box: faBox,
  industry: faIndustry,
  warehouse: faWarehouse,
  location: faMapMarkerAlt,
  map: faMap,
  globe: faGlobe,
  tower: faBroadcastTower
};

// Helper to get icon from name
export const getIconFromName = (iconName) => {
  return iconMap[iconName] || faServer;
};

export default function IconPicker({ value, onChange }) {
  const iconNames = Object.keys(iconMap);

  return (
    <div className="space-y-3">
      {value && (
        <div className="flex items-center gap-3 p-3 bg-blue-50 dark:bg-blue-950/40 rounded-lg border border-blue-200">
          <FontAwesomeIcon
            icon={getIconFromName(value)}
            className="w-8 h-8 text-blue-600"
          />
          <span className="text-sm font-medium text-gray-700 dark:text-gray-300">
            Selected: {value}
          </span>
        </div>
      )}

      <div className="grid grid-cols-6 gap-2 p-4 bg-gray-50 dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-800 max-h-64 overflow-y-auto">
        {iconNames.map((iconName) => (
          <button
            key={iconName}
            type="button"
            onClick={() => onChange(iconName)}
            className={`
              flex flex-col items-center justify-center p-3 rounded-lg border-2 transition-all
              hover:border-blue-400 hover:bg-blue-50 dark:hover:bg-blue-950/40
              ${value === iconName
                ? 'border-blue-500 bg-blue-100 dark:bg-blue-950/40'
                : 'border-gray-300 dark:border-gray-800 bg-white dark:bg-gray-900'
              }
            `}
            title={iconName}
          >
            <FontAwesomeIcon
              icon={iconMap[iconName]}
              className={`w-6 h-6 ${value === iconName ? 'text-blue-600' : 'text-gray-600 dark:text-gray-400'}`}
            />
            <span className="text-xs mt-1 text-gray-600 dark:text-gray-400 truncate w-full text-center">
              {iconName}
            </span>
          </button>
        ))}
      </div>

      {value && (
        <button
          type="button"
          onClick={() => onChange('')}
          className="text-sm text-red-600 hover:text-red-800 underline"
        >
          Clear icon
        </button>
      )}
    </div>
  );
}
